import 'whatwg-fetch'
import {
  API_URL
} from '../constants/configValues'

const station = {
  fetchStations(token, systemID, offset, limit) {
    const off = offset ?
      offset :
      0
    const li = limit ?
      limit :
      -1
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/stations/list/${off}/${li}`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateStation(token, systemID, station) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/stations/update`, {
        method: 'POST',
        headers: headerJson,
        body: JSON.stringify(station)
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteStation(token, systemID, station) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/stations/multidelete`, {
        method: 'DELETE',
        headers: headerJson,
        body: JSON.stringify([station.ID])
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default station



// WEBPACK FOOTER //
// ./src/api/station.js